import type { PlainAction } from '@components/types';
import { useModalDispatch } from '@hooks/useModalProvider';
import type { TagShort } from '@pages/User/components/tags/types';
import { getTagsTableColumns } from '@pages/User/helpers/columns/getTagsTableColumns';
import { useTags } from '@queries/fetchTags';
import withMenuLayout from '@root/src/layout/withMenuLayout';

import { MODALS } from '../../constants';

import { ReactTable } from './components';
import { useDataIsEmpty } from './hooks';

export const Tags: React.FC = () => {
  const { showModal } = useModalDispatch();
  const { data = [], status } = useTags();

  const handleEditTagClick = (tag: TagShort) => () => showModal(MODALS.ADMIN_TAG, { tag, isAdd: false });

  const columns = getTagsTableColumns({ handleEditTagClick });
  const isEmpty = useDataIsEmpty(data, status);

  const createEntityAction: PlainAction = {
    key: 'create',
    label: 'New Tag',
    onClick: () => showModal(MODALS.ADMIN_TAG, { isAdd: true }),
  };

  return (
    <ReactTable
      actions={[createEntityAction]}
      columns={columns}
      columnVisibility={{
        id: false,
      }}
      columnPinning={{ right: ['edit'] }}
      createEntityAction={createEntityAction}
      enableColumnFilters={false}
      entityName="tag"
      filteredData={data}
      initialSorting={[{ id: 'created_at', desc: true }]}
      status={status}
      isEmpty={isEmpty}
    />
  );
};

export const UserTagsPage = withMenuLayout(Tags);
